import connect from 'react-redux/es/connect/connect';
import SendBirdClient from 'sendbird';

let appId = "C14BC2EA-ED60-4A82-9441-5C312A6EA991"; 

if (process.env.REACT_APP_DEPLOYMENT_ENV === 'production') {
	appId = "AA78D7BE-1617-4F37-88C2-D9708C5E927D";
}

const sendBirdClient = new SendBirdClient( {
    appId
} );

export { sendBirdClient };